/*
 * Comcast CONFIDENTIAL
 *
 * Copyright 2003 - 2017 Comcast Corporation
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Comcast Corporation and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Comcast Corporation
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is unlawful and strictly forbidden unless prior written permission is obtained
 * from Comcast Corporation.
 */
var dependencies = ['comcast.common.authentication', 'comcast.common.communication', 'comcast.common.navigation', 'comcast.settings', 'ngMaterial', 'ngMessages', 'comcast.directives'];
var defaultName = angular.module('comcast.settings.uploadgroup', dependencies).config(['$stateProvider', function ($stateProvider) {
  $stateProvider.state('uploadgroup', {
    // Specify params that this state can access from the URL
    url: '/uploadgroup?name&{includeDisabled:bool}&pageNumber',
    parent: 'settings',
    // Specify default values for state params
    params: {
      name: null,
      pageNumber: null,
      includeDisabled: false
    },
    reloadOnSearch: true,
    views: {
      'settingsContent@settings': {
        template: '<ui-view name="uploadgroupContent"/>'
      },
      'settingsSearch@settings': {
        template: '<ui-view name="uploadgroupSearch"/>'
      },
      'uploadgroupContent@uploadgroup': {
        template: require('./uploadgroup-template.html'),
        controller: 'UploadGroupController',
        controllerAs: 'vm'
      },
      'uploadgroupSearch@uploadgroup': {
        template: require('./uploadgroupSearch-template.html'),
        controller: 'UploadGroupSearchController',
        controllerAs: 'vm'
      }
    },
    access: {
      requiresLogin: true,
      requiredPermissions: ['User'],
      permissionCheckType: 'AtLeastOne'
    }
  }).state('uploadgroupdetails', {
    url: '/:id',
    parent: 'uploadgroup',
    params: {
      gridData: null,
      pageData: null
    },
    views: {
      uploadgroupContent: {
        template: require('./uploadgroupdetail-template.html'),
        controller: 'UploadGroupDetailController',
        controllerAs: 'vm'
      },
      uploadgroupSearch: {
        template: require('./uploadgroupDetailList-template.html'),
        controller: 'UploadDetailListController',
        controllerAs: 'vm'
      }
    },
    access: {
      requiresLogin: true,
      requiredPermissions: ['User'],
      permissionCheckType: 'AtLeastOne'
    }
  });
}]).name;
export { defaultName as default, dependencies };